import { UserSearchSupportDto } from '@api/MobileClient';
import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@components/ui/button';
import { PageHeader } from '../components/page-header';
import { SortingRule, TableComponent } from '../components/table';
import { links } from '../core/router';
import { useStore } from './store';

export const Users = () => {
    const { users, sorting, setSorting, setSearchTerm, dispatch } = useStore();
    const navigate = useNavigate();

    const onSortingChange = (sorting?: SortingRule) => {
        if (sorting) {
            setSorting(sorting);
        }
    };

    return (
        <>
            <PageHeader title="Users" />

            <TableComponent<UserSearchSupportDto[]>
                items={users}
                tableLayout="auto"
                columns={[
                    {
                        Header: 'ID',
                        accessor: 'id',
                        style: { width: 20 }
                    },

                    {
                        Header: 'First name',
                        accessor: 'firstName',
                        style: { width: 100 }
                    },
                    {
                        Header: 'Last Name',
                        accessor: 'lastName',
                        style: { width: 100 }
                    },
                    {
                        Header: 'Type',
                        accessor: 'userType',
                        style: { width: 80 }
                    },
                    {
                        Header: 'Emails',
                        accessor: (row: UserSearchSupportDto) =>
                            row.emails.map((email) => (
                                <div key={email.value}>
                                    {email.value}
                                    {row.emails.length > 1 && email.main && (
                                        <strong> (primary email)</strong>
                                    )}
                                </div>
                            )),

                        id: 'emails',
                        disableSortBy: true
                    },
                    {
                        Header: '',
                        id: 'actions',
                        style: { width: 100 },
                        accessor: (user) => (
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={() =>
                                    void navigate(
                                        links.userDetails(user.id.toString())
                                    )
                                }
                            >
                                Details
                            </Button>
                        ),

                        disableSortBy: true
                    }
                ]}
                onRowClick={(user) =>
                    void navigate(links.userDetails(String(user.id)))
                }
                onPageSizeChange={(size) => dispatch({ type: 'size', size })}
                onChangePage={(page) => void dispatch({ type: 'page', page })}
                onSearchChange={(val) => void setSearchTerm(val)}
                onSortingChange={onSortingChange}
                sorting={Array.isArray(sorting) ? sorting[0] : sorting}
            />
        </>
    );
};

export default Users;
